import React, { useState, useMemo } from 'react';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
// import { ThemeProvider } from '@material-ui/styles';
import Input from '@material-ui/core/Input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
// import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import ShareIcon from '@material-ui/icons/Share';


// const useStyles = withStyles({
//     //   parent:{
//     //       display:'grid'
//     //   },
//     paper: {
//         padding: 1,
//         textAlign: 'left',
//         color: 'white',
//         whiteSpace: 'nowrap',
//         marginBottom: 1,
//     }
// });


export default function Competitions(props) {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // Use current date for filtering (no memoization needed for simple Date creation)
    const now = new Date();
    const activeCompetitions = useMemo(() => {
        return props.competitions.filter(comp => {
            if (comp.id === '0') return true; // Include new competition form
            const endDate = new Date(comp.endDate);
            return endDate >= now;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.competitions]);

    const archivedCompetitions = useMemo(() => {
        return props.competitions.filter(comp => {
            if (comp.id === '0') return false; // Exclude new competition form
            const endDate = new Date(comp.endDate);
            return endDate < now;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.competitions]);

    const displayCompetitions = tabValue === 0 ? activeCompetitions : archivedCompetitions;

    const sortedCompetitions = useMemo(() => {
        return [...displayCompetitions].sort((a, b) => {
            // Sort newest first (descending order) - use Date comparison
            const dateA = new Date(a.startDate);
            const dateB = new Date(b.startDate);
            return dateB - dateA;
        });
    }, [displayCompetitions]);

    return (
        <div className='competitions'>
            {/* <AppBar style={{ backgroundColor: 'darkgrey' }} > */}
            <div style={{ fontSize: 30, fontWeight: "bold", color: "white", borderBottom: "solid", marginBottom: '20px', paddingBottom: '10px' }}>Competitions</div>
            {/* </AppBar> */}
            <Tabs 
                value={tabValue} 
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                style={{ marginBottom: '20px', backgroundColor: 'rgba(255, 255, 255, 0.9)', borderRadius: '8px' }}
            >
                <Tab label={`Active (${activeCompetitions.length - (activeCompetitions.some(c => c.id === '0') ? 1 : 0)})`} />
                <Tab label={`Archived (${archivedCompetitions.length})`} />
            </Tabs>
            {/* <CompetitionLink group='Group' description='Competition' winner='Winner' runnerup="Runner-Up" startDate="Start Date" endDate="End Date" showTitle='true' /> */}
            <div className='gridcont'>
                {sortedCompetitions.map(card => <CompetitionRow key={card.id} {...card} setCurrentCompetition={props.setCurrentCompetition} saveNewCompetition={props.saveNewCompetition} />)}
            </div>
            {props.mgn &&
                <Fab color="primary" aria-label="add" id="AddButton" onClick={() => props.addEmptyItem()} >
                    <AddIcon />
                </Fab>
            }
        </div>
    );
};

// Invite Dialog Component
const InviteDialog = ({ open, onClose, competition }) => {
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [inviteMethod, setInviteMethod] = useState('email'); // 'email' or 'sms'

    const baseUrl = window.location.origin;
    const inviteLink = `${baseUrl}/?competition=${competition?.id || ''}`;

    const handleSendInvite = () => {
        if (inviteMethod === 'email' && email) {
            // For now, open mailto link - in production this would call a backend API
            const subject = encodeURIComponent(`Join ${competition?.description || 'Competition'} on CalorieNinja`);
            const body = encodeURIComponent(
                `You've been invited to join ${competition?.description || 'the competition'}!\n\n` +
                `Group: ${competition?.group || 'N/A'}\n` +
                `Start Date: ${competition?.startDate || 'TBD'}\n` +
                `End Date: ${competition?.endDate || 'TBD'}\n\n` +
                `Click here to join: ${inviteLink}\n\n` +
                `Sign in with Google or create an account to get started!`
            );
            window.open(`mailto:${email}?subject=${subject}&body=${body}`);
            setEmail('');
            onClose();
        } else if (inviteMethod === 'sms' && phoneNumber) {
            // For SMS, open sms: link (works on mobile devices)
            const message = encodeURIComponent(
                `Join ${competition?.description || 'Competition'} on CalorieNinja! ${inviteLink}`
            );
            window.open(`sms:${phoneNumber}?body=${message}`);
            setPhoneNumber('');
            onClose();
        }
    };

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(inviteLink);
            alert('Invite link copied to clipboard!');
        } catch (error) {
            // Fallback for browsers that don't support clipboard API
            const textArea = document.createElement('textarea');
            textArea.value = inviteLink;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                alert('Invite link copied to clipboard!');
            } catch (err) {
                console.error('Failed to copy link:', err);
                alert('Failed to copy link. Please copy it manually: ' + inviteLink);
            }
            document.body.removeChild(textArea);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Invite People to {competition?.description || 'Competition'}</DialogTitle>
            <DialogContent>
                <div style={{ marginBottom: '20px' }}>
                    <Tabs
                        value={inviteMethod}
                        onChange={(e, newValue) => setInviteMethod(newValue)}
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab label="Email" value="email" />
                        <Tab label="Text/SMS" value="sms" />
                    </Tabs>
                </div>

                {inviteMethod === 'email' && (
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Email Address"
                        type="email"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter recipient's email"
                    />
                )}

                {inviteMethod === 'sms' && (
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Phone Number"
                        type="tel"
                        fullWidth
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        placeholder="Enter recipient's phone number"
                    />
                )}

                <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>Share Link:</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <TextField
                            value={inviteLink}
                            fullWidth
                            variant="outlined"
                            size="small"
                            InputProps={{ readOnly: true }}
                        />
                        <Button onClick={handleCopyLink} variant="outlined" size="small">
                            Copy
                        </Button>
                    </div>
                </div>

                <div style={{ marginTop: '15px', fontSize: '14px', color: '#666' }}>
                    Recipients can sign in with Google or create an account using their email or phone number.
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="default">
                    Cancel
                </Button>
                <Button 
                    onClick={handleSendInvite} 
                    color="primary" 
                    variant="contained"
                    disabled={inviteMethod === 'email' ? !email : !phoneNumber}
                >
                    Send Invite
                </Button>
            </DialogActions>
        </Dialog>
    );
};

function CompetitionRow(props) {
    let startDate = new Date(props.startDate);
    let endDate = new Date(props.endDate);
    let showLink = startDate <= new Date();
    let highlight = (endDate >= new Date()) && showLink;
    return (
        <div>
            {props.id !== '0' && <CompetitionLink key={props.id} {...props} setCurrentCompetition={props.setCurrentCompetition} showLink={showLink} link='/standings/' highlight={highlight} />}
            {props.id === '0' && <CompetitionInput key={props.id} {...props} saveNewCompetition={props.saveNewCompetition} link='/' />}
        </div>
    );
};

const CompetitionLink = (props) => {
    const [inviteOpen, setInviteOpen] = useState(false);

    const handleShareClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setInviteOpen(true);
    };

    return (
        <>
            <Paper className='paper' id={props.highlight ? 'highlight' : 'paper'} style={{ flex: '1 1 calc(50% - 20px)', minWidth: '300px', position: 'relative' }}>
                <IconButton
                    style={{ position: 'absolute', top: '10px', right: '10px', color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
                    size="small"
                    onClick={handleShareClick}
                    title="Invite people to this competition"
                >
                    <ShareIcon />
                </IconButton>
                <Link to={props.link} style={{ textDecoration: 'none' }} onClick={() => props.setCurrentCompetition(props)}>
                    <div>
                        {/* <div className='competitionsTitle'></div> */}

                        {/* {!props.showTitle && props.showLink && <div className='competitionsRow'><Link to={"/standings/"} onClick={() => props.setCurrentCompetition(props)}>{props.description}</Link></div>} */}
                        <div className='competitionsRow' style={{ fontSize: '20px', marginBottom: '10px' }}>{props.description}</div>
                        <div className='competitionsRow'>Group: {props.group}</div>
                        <div className='competitionsRow'>Winner: {props.winner}</div>
                        <div className='competitionsRow'>Runner-up: {props.runnerup}</div>
                        <div className='competitionsRow'>{props.startDate} thru {props.endDate}</div>
                        {/* <div className='competitionsRow'></div> */}
                    </div>
                </Link>
            </Paper>
            <InviteDialog 
                open={inviteOpen} 
                onClose={() => setInviteOpen(false)} 
                competition={props} 
            />
        </>
    );
};

class CompetitionInput extends React.Component {
    state = {
        newRow: {}
    }
    componentDidMount = () => {
        this.setState(
            { newRow: { ...this.props } }
        )
    }
    render() {
        return (
            <Paper className='paper' id='paper' style={{ flex: '1 1 calc(50% - 20px)', minWidth: '300px' }}>
                <div>
                    {/* <div className='competitionsTitle'></div> */}
                    <div className='competitionsRow'>
                        <Input defaultValue={this.props.group} placeholder="Group"
                            onBlur={(event) => {
                                let myVal = event.target.value;
                                this.setState(prevState => ({
                                    newRow: {
                                        ...prevState.newRow,
                                        group: myVal
                                    }
                                }))
                            }
                            } />
                    </div>
                    <div className='competitionsRow'>
                        {this.props.description}
                    </div>
                    <div className='competitionsRow'>{this.props.winner}</div>
                    <div className='competitionsRow'>{this.props.runnerup}</div>
                    <div className='competitionsRow'>
                        <Input defaultValue={this.props.startDate} placeholder="YYYY-MM-DD"
                            onBlur={(event) => {
                                let myVal = event.target.value;
                                this.setState(prevState => ({
                                    newRow: {
                                        ...prevState.newRow,
                                        startDate: myVal
                                    }
                                }))
                            }
                            } />
                    </div>
                    <div className='competitionsRow'>
                        <Input defaultValue={this.props.endDate} placeholder="YYYY-MM-DD"
                            onBlur={(event) => {
                                let myVal = event.target.value;
                                this.setState(prevState => ({
                                    newRow: {
                                        ...prevState.newRow,
                                        endDate: myVal
                                    }
                                }))
                            }
                            } />

                    </div>
                    <div>
                        <FontAwesomeIcon icon={faCheck} className='check' onClick={() => this.props.saveNewCompetition(this.state.newRow)} />
                    </div>
                </div>
            </Paper>
        )
    };
};